import * as React from 'react';

import {Button} from 'shells/button/button';

type Props = {
    onClick: () => Promise<any>;
    isDisabled?: boolean;
};

export function LogActivityButton(props: Props) {
    return (
        <Button variant='primary' size='mini' onClick={props.onClick} disabled={props.isDisabled}>
            <div className='px-4'>Log activity</div>
        </Button>
    );
}
